export default __webpack_public_path__ + "static/media/icon5.92526ca2.svg";